import { load } from '@/util/router-utils.js'

import client from '../client'

export default [
  {
    path: 'consultants',
    component: load(`app/super-admin/consultants/Index`)
  },
  {
    path: 'clients',
    component: load('app/super-admin/clients/Index')
  },
  {
    path: 'activities',
    component: load('app/super-admin/activities/Index')
  },
  {
    path: 'clients/:client_id',
    redirect: 'clients/:client_id/companies'
  },
  ...client.map(item => ({
    ...item,
    path: `clients/:client_id/${item.path}`
  }))
]
